import { PATH } from "./navigation";
import { absoluteUrl, SITE_NAME, SITE_URL } from "./site";

export type PageSeoConfig = {
  title: string;
  description: string;
  path: string;
  ogImage?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
  noindex?: boolean;
};

const HOME_JSON_LD: Record<string, unknown>[] = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: SITE_URL,
    inLanguage: "it-IT",
  },
  {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Rotoinfissioni S.R.L.",
    url: SITE_URL,
    image: absoluteUrl("/favicon-bgk.png"),
    telephone: "+39-335-6996848",
    email: "commerciale@rotoinfissioni.it",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Via Vittorio Emanuele II n. 41/1",
      addressLocality: "Conselve",
      postalCode: "35026",
      addressRegion: "PD",
      addressCountry: "IT",
    },
    description:
      "Realizzazione di pali rotoinfissi, fondazioni e opere di consolidamento strutturale con tecnologie speciali.",
    areaServed: {
      "@type": "Country",
      name: "Italia",
    },
  },
];

export const PAGE_SEO_BY_PATH: Record<string, PageSeoConfig> = {
  [PATH.home]: {
    title: `${SITE_NAME} | Pali rotoinfissi e consolidamento fondazioni`,
    description:
      "Rotoinfissioni S.R.L.: pali rotoinfissi, fondazioni e consolidamento strutturale con tecnologie speciali non invasive. Conselve (PD), Veneto e Italia.",
    path: PATH.home,
    jsonLd: HOME_JSON_LD,
  },
  [PATH.about]: {
    title: `Chi siamo | ${SITE_NAME}`,
    description:
      "Storia, competenze e team di Rotoinfissioni: dal 1997 specializzati in fondazioni, pali rotoinfissi e consolidamento strutturale.",
    path: PATH.about,
  },
  [PATH.poles]: {
    title: `Pali rotoinfissi | ${SITE_NAME}`,
    description:
      "Pali rotoinfissi per fondazioni e consolidamento: soluzioni non invasive per cantieri urbani, ampliamenti e terreni difficili.",
    path: PATH.poles,
  },
  [PATH.consultancy]: {
    title: `Consulenza e coordinamento | ${SITE_NAME}`,
    description:
      "Consulenza tecnica e coordinamento per opere di fondazione e consolidamento: residenziale, commerciale e industriale.",
    path: PATH.consultancy,
  },
  [PATH.contacts]: {
    title: `Contatti | ${SITE_NAME}`,
    description:
      "Contatta Rotoinfissioni S.R.L. a Conselve (PD): telefono, email e sede per preventivi su pali rotoinfissi e consolidamenti.",
    path: PATH.contacts,
  },
  [PATH.privacy]: {
    title: `Privacy policy | ${SITE_NAME}`,
    description:
      "Informativa sul trattamento dei dati personali del sito Rotoinfissioni.",
    path: PATH.privacy,
  },
  [PATH.cookie]: {
    title: `Cookie policy | ${SITE_NAME}`,
    description: "Informativa sui cookie utilizzati dal sito Rotoinfissioni.",
    path: PATH.cookie,
  },
  [PATH.terms]: {
    title: `Termini e condizioni | ${SITE_NAME}`,
    description: "Termini e condizioni d'uso del sito web Rotoinfissioni.",
    path: PATH.terms,
  },
  [PATH.notFound]: {
    title: `Pagina non trovata | ${SITE_NAME}`,
    description: "La pagina richiesta non esiste.",
    path: PATH.notFound,
    noindex: true,
  },
};

export const getPageSeoForPath = (pathname: string): PageSeoConfig =>
  PAGE_SEO_BY_PATH[pathname] ?? PAGE_SEO_BY_PATH[PATH.home];
